import {createHelpers, getField, updateField} from 'vuex-map-fields'

const { getFieldBrandProviderItem, updateFieldBrandProviderItem } = createHelpers({
  getterType: 'getFieldBrandProviderItem',
  mutationType: 'updateFieldBrandProviderItem',
});

export default {
    state: {
        brandProviderItem: {},
    },
    actions: {
        async fetchBrandProviderItem(ctx, brandProviderID) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/provider/" + brandProviderID, requestParams);
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                return
            }
            const brandProviderItem = await res.json();
            ctx.commit('updateBrandProviderItem', brandProviderItem)
            console.log('brandProviderItem')
            console.log(brandProviderItem)
        },
        async saveBrandProviderItem(ctx, brandProviderID) {
            let csrfToken = this._vm.$readCookie('csrftoken')
            const requestParams = {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify({
                    'name': ctx.state.brandProviderItem.name,
                    'brief_name': ctx.state.brandProviderItem.brief_name,
                    'address': ctx.state.brandProviderItem.address,
                    'phone': ctx.state.brandProviderItem.phone,
                    'url': ctx.state.brandProviderItem.url,
                    'lead_day': ctx.state.brandProviderItem.lead_day,
                    'notes': ctx.state.brandProviderItem.notes,
                    'cache_hours': ctx.state.brandProviderItem.cache_hours,
                    'priority': ctx.state.brandProviderItem.priority,
                    'scrap_enable': ctx.state.brandProviderItem.scrap_enable,
                })
            };
            const res = await fetch("/api/provider/" + brandProviderID + "/", requestParams);
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                return
            }
        },
    },

    mutations: {
        updateFieldBrandProviderItem,
        updateBrandProviderItem(state, brandProviderItem) {
            state.brandProviderItem = brandProviderItem
        },
    },
    getters: {
        getFieldBrandProviderItem,
        getBrandProviderItem(state) {
            return state.brandProviderItem
        },
    }
}